import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import ImgSmilingManWithMobile from '../../../../public/images/ImgSmilingManWithMobile.png'
import { StaticImage } from '../../../image'
import { NfcLandingPageTitle } from '../NfcLandingPageTitle/NfcLandingPageTitle'

import { NfcLandingPageBenefitsSectionList } from './NfcLandingPageBenefitsSectionList'

export const NfcLandingPageBenefitsSection: FC = () => {
  const intl = useIntl()

  return (
    <div className="tablet:bg-light-brand-medium">
      <div className="container flex auto-rows-max flex-wrap items-end justify-center gap-4 overflow-hidden pb-9 tablet:grid tablet:grid-cols-2 tablet:pb-0 tablet:pt-12">
        <NfcLandingPageTitle className="order-2 mx-auto flex w-full max-w-5xl items-center justify-center px-4 tablet:order-1 tablet:col-span-2">
          <FormattedMessage id="nfc.benefits.title" />
        </NfcLandingPageTitle>

        <div className="order-1 flex h-[160px] w-full items-end justify-center bg-light-brand-medium tablet:order-2 tablet:h-auto tablet:items-center tablet:justify-end">
          <div className="flex h-full items-center tablet:hidden">
            <div className="flex size-32 items-center justify-center overflow-hidden rounded-full bg-light-tertiary p-6 text-center font-mono text-s font-medium uppercase tablet:size-60 tablet:text-3xl">
              <FormattedMessage id="nfc.benefits.badge" />
            </div>
          </div>
          <StaticImage
            alt={intl.formatMessage({ id: 'general.link.label.recipe' })}
            className="-ml-20 h-5/6 w-2/3 object-contain tablet:mr-16"
            src={ImgSmilingManWithMobile}
          />
        </div>

        <div className="order-3 m-auto flex w-full max-w-5xl items-start px-4 tablet:order-3">
          <NfcLandingPageBenefitsSectionList />
        </div>
      </div>
    </div>
  )
}
